
import {Form,Container,Row,Col} from "react-bootstrap"
const Editmodal =()=>{
return(<>

<Container>
  <Row >
    <Col lg="3" sm="3" md="3" className="form-row  Backgroundbox mt-2">
    <Form>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Control type="text" placeholder="write" className="w-50" />
   </Form.Group>

     
    </Form>
    <div className="modal-body boxes ">
                    <Form.Select
                      aria-label="Default select example"
                      className="select_box_W"
                    >
                      <option>Public</option>
                      <option value="1">Friends</option>
                      <option value="2">Only me</option>
                    </Form.Select>

                    <div className="pt-1">
                      <button
                        type="button"
                        className="btn  me-2 bg-red text-white p-1"
                    
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn bg-blue text-white p-1"
                        data-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </div>
    </Col>
  </Row>
</Container>

    
              
</>)

}

export default Editmodal